module.exports = __webpack_public_path__ + "static/Number 102-23bb56194d7f7d6e71ae2e848b70504b.jpg";